module.exports = __webpack_public_path__ + "static/media/warning.33153b7b.png";